import moment from "moment";

import { getAccountManagers } from "../../Pages/api";
import { showAppError } from "../../Utils/error";
import {
  setManagerDataFetchedAt,
  setManagers,
  setManagersLoading,
} from "../Reducers/appReducer";

const fetchManagers = () => async (dispatch, getState) => {
  try {
    const { app } = getState();
    if (app.managerState.managersLoading) {
      return;
    }
    if (
      app.managerState.managerDataFetchedAt &&
      moment(app.managerState.managerDataFetchedAt).isSameOrBefore(
        moment().add(3, "hours")
      )
    ) {
      return;
    }
    dispatch(setManagersLoading(true));
    const response = await getAccountManagers();
    if (response.code === 201) {
      dispatch(setManagers(response.result?.accountManagers || []));
      dispatch(setManagerDataFetchedAt(moment().toISOString()));
    } else {
      showAppError(response);
    }
  } catch (error) {
    showAppError(error);
  } finally {
    dispatch(setManagersLoading(false));
  }
};

const tempFunction = () => {
  console.log("tempFunction");
};

export { fetchManagers, tempFunction };
